import { UserContext } from 'context/UserContext';
import { useMantaCareAPI } from 'hooks/useMantaCareAPI/useMantaCareAPI';
import { useContext, useEffect, useState } from 'react';

export const useQuestionnaireData = () => {
    const { getQuestionnaireDataForUser, loading, error } = useMantaCareAPI();
    const { user } = useContext(UserContext);
    const [questionnarireData, setQuestionnaireData] = useState();

    useEffect(() => {
        if (!user) {
            return;
        }
        (async () => {
            const response = await getQuestionnaireDataForUser(user.id);
            setQuestionnaireData(response);
        })();
    }, [user]);

    return {
        isLoading: loading,
        data: questionnarireData,
        error
    };
};
